export const RSV_SERVICE_REGIONS = [
    {id: 'shanghai', label: '上海市', province: '上海市', city: '上海市'},
    {id: 'jiaxing', label: '浙江省 嘉兴市', province: '浙江省', city: '嘉兴市'},
    {id: 'huzhou', label: '浙江省 湖州市', province: '浙江省', city: '湖州市'},
    {id: 'qinghai', label: '青海省', province: '青海省', city: ''},
    {id: 'wuhan', label: '湖北省 武汉市', province: '湖北省', city: '武汉市'}
];

export const getRsvRegionByLocation = (province, city) => (
    RSV_SERVICE_REGIONS.find(region => (
        region.province === province && region.city === city
    )) || null
);

// Stable IDs: retired ID 6 belongs to 陆家嘴 and must not be reused.
export const RSV_SHANGHAI_SITES = [
    {id: 'rsv-shanghai-1', name: '嘉定区中心医院'},
    {id: 'rsv-shanghai-2', name: '上海第十人民医院'},
    {id: 'rsv-shanghai-3', name: '莘庄社区卫生服务中心'},
    {id: 'rsv-shanghai-4', name: '新泾社区卫生服务中心'},
    {id: 'rsv-shanghai-5', name: '花木社区卫生服务中心'},
    {id: 'rsv-shanghai-7', name: '上钢社区卫生服务中心'},
    {id: 'rsv-shanghai-8', name: '北蔡社区卫生服务中心'},
];

export const RSV_HOSPITALS = {
    '上海市': RSV_SHANGHAI_SITES.map(site => site.name),
    '嘉兴市': ['长水街道社区卫生服务中心', '魏塘街道社区卫生服务中心'],
    '青海省': ['城关社区卫生服务中心'],
};
